import React, { createContext, useState, useEffect, useContext } from 'react';
import api from '../api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check local storage for existing session
    const token = localStorage.getItem('lms_token');
    const storedUser = localStorage.getItem('lms_user');

    if (token && storedUser) {
      try {
        // 1. Parse stored user
        const parsedUser = JSON.parse(storedUser);
        
        // 2. Decode JWT to get the REAL role (Security fix: prevent LocalStorage hacking)
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        const decoded = JSON.parse(jsonPayload);
        
        // 3. Force the role from the token, not from local storage
        setUser({ ...parsedUser, role: decoded.role });
      } catch (err) {
        console.error("Invalid token found", err);
        logout();
      }
    }
    setLoading(false);

    // Listen for custom token expiration event thrown by api.js
    const handleAuthExpired = () => {
      setUser(null);
    };
    window.addEventListener('auth-expired', handleAuthExpired);
    return () => window.removeEventListener('auth-expired', handleAuthExpired);
  }, []);

  const login = async (username, password) => {
    try {
      const res = await api.post('/login.php', { username, password });


      if (res.data.success) {
        localStorage.setItem('lms_token', res.data.token);
        localStorage.setItem('lms_user', JSON.stringify(res.data.user));
        setUser(res.data.user);
        return { success: true };
      }
      return { success: false, error: 'Login failed' };
    } catch (err) {
      return { success: false, error: err.response?.data?.error || err.message };
    }
  };

  const logout = () => {
    localStorage.removeItem('lms_token');
    localStorage.removeItem('lms_user');
    setUser(null);
  };

  const updateProfile = (updatedUser) => {
    localStorage.setItem('lms_user', JSON.stringify(updatedUser));
    setUser(prev => ({ ...prev, ...updatedUser }));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateProfile }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
